module.exports = __webpack_public_path__ + "static/img/ecaray_about_introduction_honor10.69c53d20.png";